var render, staticRenderFns
import script from "./DdTableColumn.vue?vue&type=script&lang=js&"
export * from "./DdTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db8829b",
  null
  
)

export default component.exports